//IOS注册
function setupWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(WebViewJavascriptBridge);
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }
  window.WVJBCallbacks = [callback];
  var WVJBIframe = document.createElement('iframe');
  WVJBIframe.style.display = 'none';
  WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(function() {
    document.documentElement.removeChild(WVJBIframe)
  }, 0)
}

// JS调用IOS
const iosApi = function(ApiName, params, callback) {
  setupWebViewJavascriptBridge(function(bridge) {
    bridge.callHandler(ApiName, params, function responseCallback(responseData) {
      console.log("JS received response:", responseData)
      callback(responseData)
    })
  })
}
export default {
  iosApi
}



//////////////////
// WEBPACK FOOTER
// ./static/js/bridge.js
// module id = null
// module chunks = 